import {Injectable} from '@angular/core';
import {Carrier} from './carrier';
import {Department} from './department';

@Injectable()
export class Session {
  accessTokenKey = 'taskr_accessToken';
  refreshTokenKey = "taskr_refreshToken"
  userNameKey = 'taskr_userName';
  companyIdKey = 'taskr_companyId';
  companyNameKey = 'taskr_companyName';
  userIdKey = 'taskr_userId';
  userTypeKey = 'taskr_userType';
  carriersKey = 'taskr_carriers';
  departmentsKey = 'taskr_departments';
  allowUserMaintenanceKey = "taskr_allowUserMaintenance";
  showAssignOrderToUserKey = "taskr_showAssignOrderToUser";
  showAssignShipmentToCarrierKey = "taskr_showAssignShipmentToCarrier";
  enableShipmentLabelPrintingKey = "taskr_enableShipmentLabelPrinting";

  isValid(): boolean {
    return !!localStorage.getItem(this.accessTokenKey);
  }

  reset() {
    localStorage.removeItem(this.accessTokenKey);
    localStorage.removeItem(this.userNameKey);
    localStorage.removeItem(this.companyIdKey);
    localStorage.removeItem(this.companyNameKey);
    localStorage.removeItem(this.userIdKey);
    localStorage.removeItem(this.userNameKey);
    localStorage.removeItem(this.departmentsKey);
    localStorage.removeItem(this.refreshTokenKey)
  }

  setUserProperties(userFullName: string, companyId: string, companyName: string, userId: string, userType: string) {
    localStorage.setItem(this.companyIdKey, companyId);
    localStorage.setItem(this.companyNameKey, companyName);
    localStorage.setItem(this.userIdKey, userId);
    localStorage.setItem(this.userTypeKey, userType);
    localStorage.setItem(this.userNameKey, userFullName);
  }

  setTokens(accessToken: string, refreshToken: string) {
    localStorage.setItem(this.accessTokenKey, accessToken);
    localStorage.setItem(this.refreshTokenKey, refreshToken);
  }

  getAccessToken(): string {
    return localStorage.getItem(this.accessTokenKey);
  }

  getRefreshToken(): string {
    return localStorage.getItem(this.refreshTokenKey);
  }

  getCompanyId(): string {
    return localStorage.getItem(this.companyIdKey);
  }

  getCompanyName(): string {
    return localStorage.getItem(this.companyNameKey);
  }

  getUserId(): string {
    return localStorage.getItem(this.userIdKey);
  }

  getUserType(): string {
    return localStorage.getItem(this.userTypeKey);
  }

  getUserName() {
    return localStorage.getItem(this.userNameKey);
  }

  setAllowUserMaintenance(allowed: boolean) {
    localStorage.setItem(this.allowUserMaintenanceKey, allowed.toString())
  }

  userMaintenanceIsAllowed(): boolean {
    let value = localStorage.getItem(this.allowUserMaintenanceKey);

    return value == "true";
  }

  setEnableShipmentLabelPrinting(enabled: boolean) {
    localStorage.setItem(this.enableShipmentLabelPrintingKey, enabled.toString())
  }

  shipmentLabelPrintingIsEnabled(): boolean {
    let value = localStorage.getItem(this.enableShipmentLabelPrintingKey)

    return value == "true"
  }

  setShowAssignOrderToUser(show: boolean) {
    localStorage.setItem(this.showAssignOrderToUserKey, show.toString())
  }

  showAssignOrderToUser(): boolean {
    let value = localStorage.getItem(this.showAssignOrderToUserKey);

    return value == "true";
  }

  setShowAssignShipentToCarrier(show: boolean) {
    localStorage.setItem(this.showAssignShipmentToCarrierKey, show.toString())
  }

  showAssignShipmentToCarrier(): boolean {
    let value = localStorage.getItem(this.showAssignShipmentToCarrierKey);

    return value == "true";
  }

  setCarriers(carriers: Carrier[]) {
    localStorage.setItem(this.carriersKey, JSON.stringify(carriers))
  }

  getCarriers(): Carrier[] {
    let carriers =  JSON.parse(localStorage.getItem(this.carriersKey));

    if (carriers === null) {
      return [];
    }
    return carriers;
  }

  setDepartments(departments: Department[]) {
    localStorage.setItem(this.departmentsKey, JSON.stringify(departments))
  }

  getDepartments(): Department[] {
    let departments =  JSON.parse(localStorage.getItem(this.departmentsKey));

    if (departments === null) {
      return [];
    }
    return departments;
  }
}
